var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"tdNone phone",attrs:{"href":`tel:${_vm.phone}`}},[_vm._v("\n  "+_vm._s(_vm.phone)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }